<template>
	<div class="login-wrap">
		<div class="ms-logo">
		</div>
		<div class="ms-login">
			<div class="ms-title">FCS系统</div>
			<el-form :model="param" :rules="rules" ref="login" label-width="70px" class="ms-content" v-loading="loading"
				element-loading-text="登录中..." element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)">
				<el-form-item label="账号" prop="username">
					<el-input v-model="param.username" placeholder="请输入账号" maxlength='11'>
						<!-- <template #prepend>
							<el-button icon="el-icon-user"></el-button>
						</template> -->
					</el-input>
				</el-form-item>
				<el-form-item label="密码" prop="password">
					<el-input type="password" placeholder="请输入密码" v-model="param.password" @keyup.enter="submitForm()">
						<!-- <template #prepend>
							<el-button icon="el-icon-lock"></el-button>
						</template> -->
					</el-input>
				</el-form-item>
				<el-form-item label="角色" prop="Scope">
					<el-select v-model="param.Scope" placeholder="请选择角色">
						<el-option label="系统管理员" value="5d59a2fe-5f94-4671-8394-e2fefdb6d2ed"></el-option>
						<el-option label="总评" value="002860b9-6844-4982-9ac4-5453c9cdea3c"></el-option>
						<el-option label="评级师" value="a348ae2d-fb9c-4675-856c-936aa6c103c5"></el-option>
						<el-option label="客服" value="2d7a48e5-503b-463e-878a-361e1b175551"></el-option>
						<el-option label="经销商" value="a591fe1e-7da8-4124-8912-b5af5282d57a"></el-option>
					</el-select>
				</el-form-item>
				<div class="login-btn">
					<el-button type="primary" @click="submitForm()">登录</el-button>
				</div>
				<div id="" style="float: right;">
					<!-- <a href="register" style="color: #fff">会员注册</a> -->
				</div>
			</el-form>
		</div>
		<div class="ms-footer">
			FCS 智能管理系统
		</div>
		<!-- <div class="ms-about" @click="openAbout()">
			联系我们
		</div>
 -->
		<el-dialog class="loginDialog" :title="AboutTitle" v-model="AboutEditVisible" width="700px">
			<h2>公司内线:(0316)5898888</h2>
			<div>
				<el-tabs v-model="activeName">
					<el-tab-pane label="物控审核" name="first">
						<el-table :data="tableData1" border class="table" ref="multipleTable"
							header-cell-class-name="table-header" @selection-change="handleSelectionChange"
							style="width: 100%">
							<el-table-column prop="Name" label="姓名" align="center"></el-table-column>
							<el-table-column prop="TelePhone" label="分机" align="center"></el-table-column>
						</el-table>
						<div class="pagination">
							<el-pagination background layout="total, prev, pager, next" :current-page="query1.pageIndex"
								:page-size="query1.pageSize" :total="pageTotal1" @current-change="handlePageChange1">
							</el-pagination>
						</div>
					</el-tab-pane>
					<el-tab-pane label="仓库收货" name="second">
						<el-table :data="tableData2" border class="table" ref="multipleTable"
							header-cell-class-name="table-header" @selection-change="handleSelectionChange"
							style="width: 100%">
							<el-table-column prop="Name" label="姓名" align="center"></el-table-column>
							<el-table-column prop="TelePhone" label="分机" align="center"></el-table-column>
						</el-table>
						<div class="pagination">
							<el-pagination background layout="total, prev, pager, next" :current-page="query2.pageIndex"
								:page-size="query2.pageSize" :total="pageTotal2" @current-change="handlePageChange2">
							</el-pagination>
						</div>
					</el-tab-pane>
					<el-tab-pane label="系统运维" name="third">
						<el-table :data="tableData3" border class="table" ref="multipleTable"
							header-cell-class-name="table-header" @selection-change="handleSelectionChange"
							style="width: 100%">
							<el-table-column prop="Name" label="姓名" align="center"></el-table-column>
							<el-table-column prop="TelePhone" label="分机" align="center"></el-table-column>
						</el-table>
						<div class="pagination">
							<el-pagination background layout="total, prev, pager, next" :current-page="query3.pageIndex"
								:page-size="query3.pageSize" :total="pageTotal3" @current-change="handlePageChange3">
							</el-pagination>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	// import $ from 'jquery'
	import axios from 'axios';
	import qs from 'qs';
	export default {
		data() {
			return {
				param: {
					username: "",
					password: "",
					Scope: ""
				},
				rules: {
					username: [{
						required: true,
						message: "请输入用户名",
						trigger: "blur"
					}, {
						pattern: /^1[0123456789]\d{9}$/,
						message: '目前只支持中国大陆的手机号码',
						trigger: "blur"
					}],
					password: [{
						required: true,
						message: "请输入密码",
						trigger: "blur"
					}],
					Scope: [{
						required: true,
						message: "请选择角色",
						trigger: "blur"
					}]
				},
				loading: false,
				AboutTitle: "通讯录",
				AboutEditVisible: false,
				tableData1: [],
				tableData2: [],
				tableData3: [],
				activeName: 'first',
				pageSize: 5,
				pageIndex: 0,
				query1: {
					pageIndex: 0,
					pageSize: 5
				},
				query2: {
					pageIndex: 0,
					pageSize: 5
				},
				query3: {
					pageIndex: 0,
					pageSize: 5
				},
				pageTotal1: 0,
				pageTotal2: 0,
				pageTotal3: 0,
			};
		},
		created() {
			localStorage.clear()
			this.getData()
		},
		methods: {
			getData() {
				// var pageIndex = this.pageIndex;
				// var pageSize = this.pageSize;
				// axios({
				// 	method: 'GET',
				// 	url: this.$store.state.pcurl+"GetAddressBookUser?roleid=db4bcfdc-7680-482a-a6e6-d4cead016835&pageIndex=" + pageIndex +
				// 		"&pageSize=" + pageSize
				// }).then((res) => {
				// 	if (res.status == 200) {
				// 		this.tableData1 = res.data.Data;
				// 		this.pageTotal1 = res.data.Count;
				// 	} else {
				// 		this.$message.error('获取通讯录失败');
				// 	}
				// }).catch(() => {
				// 	this.$message.error('获取通讯录失败');
				// })
				// axios({
				// 	method: 'GET',
				// 	url: this.$store.state.pcurl+"GetAddressBookUser?roleid=02dac558-d8da-4709-a5ad-962a848c7daa&pageIndex=" + pageIndex +
				// 		"&pageSize=" + pageSize
				// }).then((res) => {
				// 	if (res.status == 200) {
				// 		this.tableData2 = res.data.Data;
				// 		this.pageTotal2 = res.data.Count;
				// 	} else {
				// 		this.$message.error('获取通讯录失败');
				// 	}
				// }).catch(() => {
				// 	this.$message.error('获取通讯录失败');
				// })
				// axios({
				// 	method: 'GET',
				// 	url: this.$store.state.pcurl+"GetAddressBookUser?roleid=0d241e60-58a2-431b-bad5-a887e5c60e49&pageIndex=" + pageIndex +
				// 		"&pageSize=" + pageSize
				// }).then((res) => {
				// 	if (res.status == 200) {
				// 		this.tableData3 = res.data.Data;
				// 		this.pageTotal3 = res.data.Count;
				// 	} else {
				// 		this.$message.error('获取通讯录失败');
				// 	}
				// }).catch(() => {
				// 	this.$message.error('获取通讯录失败');
				// })
			},
			submitForm() {
				this.$refs.login.validate(valid => {
					if (valid) {
						this.loading = true;
						var data = {
							username: this.param.username,
							password: this.param.password,
							Scope: this.param.Scope,
							grant_type: 'password'
						};
						axios({
							method: 'POST',
							url: this.$store.state.url + 'token',
							data: qs.stringify(data),
							headers: {
								'Content-Type': 'application/x-www-form-urlencoded'
							},
						}).then((res) => {
							this.loading = false;
							this.$message.success('登录成功');
							let access_token = res.data.access_token;
							localStorage.setItem("access_token", access_token);

							axios({
								method: 'GET',
								url: this.$store.state.pcurl + "GetLoginInfo",
								headers: {
									"Authorization": "bearer " + access_token + ""
								},
							}).then((res) => {
								console.log(res)
								let Id = res.data.Data.Id; //当前登录用户Id
								localStorage.setItem("Id", Id);

								let RoleId = res.data.Data.RoleId; //当前登录用户角色
								localStorage.setItem("RoleId", RoleId);

								let username = res.data.Data.Name; //当前登录用户名
								localStorage.setItem("ms_username", username);

								if (res.data.Status == 200) {


									//管理员
									if (RoleId == '5d59a2fe-5f94-4671-8394-e2fefdb6d2ed') {
										this.$router.push("/person");
									}
									//总评
									if (RoleId == '002860b9-6844-4982-9ac4-5453c9cdea3c') {
										this.$router.push("/member");
									}
									//评级师
									if(RoleId == 'a348ae2d-fb9c-4675-856c-936aa6c103c5'){
										this.$router.push("/Ratingpool");
									}
									//客服
									if(RoleId == '2d7a48e5-503b-463e-878a-361e1b175551'){
										this.$router.push("/newsActive");
									}
									//经销商
									if(RoleId == 'a591fe1e-7da8-4124-8912-b5af5282d57a'){
										this.$router.push("/pingjiList");
									}
									

									// if (RoleId == "c7e8274b-5d71-4562-9243-49dbf0cd4137") {
									// 	// 管理员
									// 	this.$router.push("/driver");
									// } else if (RoleId == "705d2a4d-d53b-4182-aad5-2b4cb6c5e2eb") {
									// 	// 供应商
									// 	this.$router.push("/driver");
									// } else if (RoleId == "98a57f67-338e-4fc5-9df5-f8177f42994c") {
									// 	// 操作员
									// 	this.$router.push("/PlanPlatform");
									// } else if (RoleId == "d6e8274b-5d71-4562-9243-49dbf0cd4137") {
									// 	// 审核员
									// 	this.$router.push("/examine");
									// }
								} else {
									this.$message.error('获取角色信息失败');
								}
							}).catch(() => {
								this.$message.error('获取角色信息失败');
							})

						}).catch((error) => {
							this.loading = false;
							// console.log(error.response.data.error_description)
							this.$message.error(error.response.data.error_description);
						})
					} else {
						return false;
					}
				});
			},
			register() {
				this.$router.push({
					name: 'Register'
				})
			},
			openAbout() {
				this.AboutEditVisible = true;
			},
			// 分页导航
			// handlePageChange1(val) {
			// 	var pageIndex = val - 1;
			// 	var pageSize = this.pageSize;
			// 	axios({
			// 		method: 'GET',
			// 		url: this.$store.state.pcurl+"GetAddressBookUser?roleid=db4bcfdc-7680-482a-a6e6-d4cead016835&pageIndex=" + pageIndex +
			// 			"&pageSize=" + pageSize
			// 	}).then((res) => {
			// 		if (res.status == 200) {
			// 			this.tableData1 = res.data.Data;
			// 			this.pageTotal1 = res.data.Count;
			// 		} else {
			// 			this.$message.error('获取通讯录失败');
			// 		}
			// 	}).catch(() => {
			// 		this.$message.error('获取通讯录失败');
			// 	})
			// },
			// handlePageChange2(val) {
			// 	var pageIndex = val - 1;
			// 	var pageSize = this.pageSize;
			// 	axios({
			// 		method: 'GET',
			// 		url: this.$store.state.pcurl+"GetAddressBookUser?roleid=02dac558-d8da-4709-a5ad-962a848c7daa&pageIndex=" + pageIndex +
			// 			"&pageSize=" + pageSize
			// 	}).then((res) => {
			// 		if (res.status == 200) {
			// 			this.tableData2 = res.data.Data;
			// 			this.pageTotal2 = res.data.Count;
			// 		} else {
			// 			this.$message.error('获取通讯录失败');
			// 		}
			// 	}).catch(() => {
			// 		this.$message.error('获取通讯录失败');
			// 	})
			// },
			// handlePageChange3(val) {
			// 	var pageIndex = val - 1;
			// 	var pageSize = this.pageSize;
			// 	axios({
			// 		method: 'GET',
			// 		url: this.$store.state.pcurl+"GetAddressBookUser?roleid=0d241e60-58a2-431b-bad5-a887e5c60e49&pageIndex=" + pageIndex +
			// 			"&pageSize=" + pageSize
			// 	}).then((res) => {
			// 		if (res.status == 200) {
			// 			this.tableData3 = res.data.Data;
			// 			this.pageTotal3 = res.data.Count;
			// 		} else {
			// 			this.$message.error('获取通讯录失败');
			// 		}
			// 	}).catch(() => {
			// 		this.$message.error('获取通讯录失败');
			// 	})
			// },
		}
	};
</script>

<style scoped>
	.login-wrap {
		position: relative;
		width: 100%;
		height: 100%;
		background: url(../assets/loginbgc.jpg) no-repeat;
		background-size: cover;
	}

	:deep(.el-form-item__label) {
		color: #fff !important;
	}

	:deep(.el-form-item__label::before) {
		content: '' !important;
	}

	.ms-title {
		width: 100%;
		line-height: 50px;
		text-align: center;
		font-size: 20px;
		color: #fff;
		border-bottom: 1px solid #ddd;
	}

	.ms-footer {
		position: absolute;
		right: 0;
		bottom: 5%;
		width: 200px;
		color: #fff;
		font-size: 20px;
	}

	.screen img {
		position: absolute;
		width: 50px;
		left: 2%;
		bottom: 5%;
	}

	.ms-about {
		position: absolute;
		left: 50%;
		bottom: 5%;
		width: 350px;
		color: #fff;
		margin: -190px 0 0 -175px;
		font-size: 20px;
		text-align: center;
		cursor: pointer;
	}

	.ms-login {
		position: absolute;
		left: 75%;
		top: 50%;
		width: 350px;
		margin: -190px 0 0 -175px;
		border-radius: 5px;
		background: rgba(255, 255, 255, 0.3);
		overflow: hidden;
		box-shadow: 10px 10px 20px #000000;
	}

	.ms-content {
		padding: 30px 30px 30px 10px;
	}

	.el-select {
		width: 100%;
	}

	.login-btn {
		margin-left: 50px;
		text-align: center;
	}

	.login-btn button {
		width: 100%;
		height: 36px;
		margin-bottom: 10px;
	}

	.login-tips {
		font-size: 12px;
		line-height: 30px;
		color: #fff;
	}

	.register {
		margin-left: 0;
	}
</style>

<!-- <style type="text/css">
	.el-dialog__body {
		padding: 0 20px;
	}
</style> -->
